import type { ReactNode } from "react";

// The header every tab opens with: eyebrow, title, one line of explanation,
// and a status card (a summary plus the latest message). Keeping it in one
// place is what keeps the tabs the same size and rhythm.
export function PageIntro({ eyebrow, title, text, summary, message }: {
  eyebrow: string; title: string; text: ReactNode; summary: ReactNode; message: string;
}) {
  return <section className="intro wrap">
    <div><p className="eyebrow">{eyebrow}</p><h1>{title}</h1><p>{text}</p></div>
    <div className="status-card" role="status">{summary}<br/><span>{message}</span></div>
  </section>;
}
